import React from 'react';
import { Button } from '@cxc/react-fpds-components';
import { Download } from '@cxc/react-fpds-icons';
import { ZappyButtonProps } from '../../types/props/ZappyButtonProps';

const ZappyButton: React.FC<ZappyButtonProps> = ({
    label,
    buttonType,
    onClick,
    disabled,
    dataTestId,
}) => {
    const renderIcon = () => {
        if (label === 'Export (.pdf)') return <Download size={'s'} data-testid="export-icon" />;
        return null;
    };
    return (
        <Button
            onClick={onClick}
            size="small"
            buttonColor="default"
            buttonType={buttonType}
            as="button"
            dataTestId={dataTestId}
            isDisabled={disabled}
            style={{ cursor: disabled ? 'default' : 'pointer' }}
        >
            {renderIcon()}
            {renderIcon() && <span style={{ margin: '2px' }}></span>}
            {label}
        </Button>
    );
};

export default ZappyButton;
